import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { NavLink } from 'react-router-dom';
import useBannerHomeStyles from '../../styles/ncp2026/banner_home';
import bannerDesktop from '../../assets/images/kozel_battle/banner-campanie-hp.jpg';
import bannerMobile from '../../assets/images/kozel_battle/banner_mobile.jpg';
import { paths } from '../../AppRouters';

const HomeBanner: React.FC = () => {
    const bannerHomeStyles = useBannerHomeStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <NavLink to={paths.kozelBattle} className={bannerHomeStyles.navLink}>
            <img
                src={isMobile ? bannerMobile : bannerDesktop}
                alt="Kozel Battle - Înscrie-te"
                className={bannerHomeStyles.bannerImage}
            />
        </NavLink>
    );
};

export default HomeBanner;